// menu-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Abastecimentos": "Cargas de Combustible",
    "Adição por Abastecimento": "Adición por Carga de Combustible",
    "Adição por Cupom": "Adición por Cupón",
    "Admin": "Admin",
    "Agente de Suporte": "Agente de Soporte",
    "Alertas": "Alertas",
    "Análise de Segurança": "Análisis de Seguridad",
    "Aplicativo": "Aplicación",
    "Aprovar Pendências": "Aprobar Pendientes",
    "Avaliação de Postos": "Evaluación de Estaciones",
    "Avaliação nas Lojas": "Evaluación en las Tiendas",
    "Avaliações": "Evaluaciones",
    "Bloqueados": "Bloqueados",
    "Bolões": "Quinielas",
    "CNPJs excluídos": "CNPJs excluidos",
    "Cadastro": "Registro",
    "Cashback de abastecimento": "Cashback de carga de combustible",
    "Categorias": "Categorías",
    "Cidades": "Ciudades",
    "Clientes": "Clientes",
    "Clientes ignorados": "Clientes ignorados",
    "Clientes sem Número": "Clientes sin Número",
    "Clube de Vantagens": "Club de Beneficios",
    "Cobranças": "Cobros",
    "Combustíveis": "Combustibles",
    "Combustíveis pai": "Combustibles padre",
    "Configurações": "Configuración",
    "Confirmação de clientes": "Confirmación de clientes",
    "Contas a pagar": "Cuentas por pagar",
    "Contato": "Contacto",
    "Contingências RDP": "Contingencias RDP",
    "Cupons": "Cupones",
    "Dashboard": "Panel",
    "Dashboard Comentários": "Panel Comentarios",
    "Descontos": "Descuentos",
    "Desempenho das notificações": "Desempeño de las notificaciones",
    "Desvalidar Cupom": "Invalidar Cupón",
    "Detalhados": "Detallados",
    "Dispositivos": "Dispositivos",
    "Distribuídos": "Distribuidos",
    "Dotz": "Dotz",
    "Ecosystem Hub": "Ecosystem Hub",
    "Em Andamento": "En Curso",
    "Enquetes": "Encuestas",
    "Enquetes de avaliação": "Encuestas de evaluación",
    "Envio em Massa": "Envío Masivo",
    "Envios": "Envíos",
    "Erros": "Errores",
    "Especiais": "Especiales",
    "Estoque mínimo": "Stock mínimo",
    "Estornados": "Revertidos",
    "Estornar Cupom": "Revertir Cupón",
    "Etiquetas": "Etiquetas",
    "Evolução do Produto": "Evolución del Producto",
    "Evolução mensal": "Evolución mensual",
    "Expirados por cliente": "Expirados por cliente",
    "Expirados por dia": "Expirados por día",
    "Expiração": "Expiración",
    "Faturamento": "Facturación",
    "Faturas": "Facturas",
    "Favoritos": "Favoritos",
    "Financeiro": "Financiero",
    "Geral": "General",
    "Grupos de Permissões": "Grupos de Permisos",
    "Grupos de Postos": "Grupos de Estaciones",
    "Grupos de clientes": "Grupos de clientes",
    "Histórico de Alterações": "Historial de Cambios",
    "Home": "Inicio",
    "Hora do Concentrador": "Hora del Concentrador",
    "Imagens": "Imágenes",
    "Imagens da Home": "Imágenes del Inicio",
    "Inativos": "Inactivos",
    "Inconsistências": "Inconsistencias",
    "Indicações": "Referidos",
    "Integrações de Cupom": "Integraciones de Cupón",
    "Limites": "Límites",
    "Mapa ao Vivo": "Mapa en Vivo",
    "Marketing": "Marketing",
    "Mensagens": "Mensajes",
    "Meta de Frentista": "Objetivo del Playero",
    "Meta de frentista": "Objetivo del playero",
    "Metas Batidas": "Objetivos Alcanzados",
    "Mov. de estoque(Resumo)": "Mov. de stock (Resumen)",
    "Movimentação de estoque": "Movimiento de stock",
    "NOVO": "NUEVO",
    "Notificações Push": "Notificaciones Push",
    "Notícias": "Noticias",
    "Novidades": "Novedades",
    "Novo: Clube de Vantagens!": "¡Nuevo: Club de Beneficios!",
    "Novo: Dashboard de Comentários!": "¡Nuevo: Panel de Comentarios!",
    "Novo: Imagens do aplicativo": "Nuevo: Imágenes de la aplicación",
    "Novo: Meta de Frentista!": "¡Nuevo: Objetivo del Playero!",
    "Novo: Painel 360!": "¡Nuevo: Panel 360!",
    "Novos Clientes": "Nuevos Clientes",
    "Não validados": "No validados",
    "Número de Abastecimentos": "Número de Cargas de Combustible",
    "Números de WhatsApp": "Números de WhatsApp",
    "Padrão": "Estándar",
    "Pagamentos": "Pagos",
    "Pagamentos por Pix": "Pagos por Pix",
    "Painel 360": "Panel 360",
    "Parceiros": "Socios",
    "Parceiros Externos": "Socios Externos",
    "Pendentes": "Pendientes",
    "Penetração do app": "Penetración de la aplicación",
    "Perfis": "Perfiles",
    "Permissões": "Permisos",
    "Pontuação Padrão": "Puntuación Estándar",
    "Pontuações": "Puntuaciones",
    "Pontuações reformulado!": "¡Puntuaciones renovadas!",
    "Pop-ups": "Pop-ups",
    "Por Cliente": "Por Cliente",
    "Por Combustível": "Por Combustible",
    "Por Frentista": "Por Playero",
    "Por Grupo": "Por Grupo",
    "Por Intervalo": "Por Intervalo",
    "Por Posto": "Por Estación",
    "Por Promoter": "Por Promotor",
    "Por Venda (API)": "Por Venta (API)",
    "Por marca": "Por marca",
    "Posição de estoque": "Posición de stock",
    "Postos de combustível": "Estaciones de servicio",
    "Postos sem Boleto": "Estaciones sin Boleto",
    "Preço do Combustível": "Precio del Combustible",
    "Preço real": "Precio real",
    "Prim. Abast. por Frentista": "Prim. Carga por Playero",
    "Prim. Abast. por Posto": "Prim. Carga por Estación",
    "Produtos": "Productos",
    "Produtos Destaque": "Productos Destacados",
    "Produtos de Venda": "Productos de Venta",
    "Produtos em dinheiro": "Productos en dinero",
    "Promoters": "Promotores",
    "Quantidade Mínima": "Cantidad Mínima",
    "Reajuste": "Reajuste",
    "Recargas Elétricas": "Recargas Eléctricas",
    "Reconciliação": "Reconciliación",
    "Recorrentes": "Recurrentes",
    "Recuperação de Clientes": "Recuperación de Clientes",
    "Regras": "Reglas",
    "Regras de Pontuação": "Reglas de Puntuación",
    "Regras de Sorteio": "Reglas de Sorteo",
    "Relatório IA": "Reporte IA",
    "Relatórios": "Reportes",
    "Resgatados": "Canjeados",
    "Resgate X Pontos": "Canje X Puntos",
    "Revendas": "Revendedores",
    "Roleta": "Ruleta",
    "Roletas": "Ruletas",
    "SMS": "SMS",
    "Saldo Negativo": "Saldo Negativo",
    "Saldo de Pontos": "Saldo de Puntos",
    "Segurança": "Seguridad",
    "Serviços": "Servicios",
    "Sorteios": "Sorteos",
    "Sugestão de compra": "Sugerencia de compra",
    "Textos do aplicativo": "Textos de la aplicación",
    "Top Clientes": "Top Clientes",
    "Transações Aprovadas": "Transacciones Aprobadas",
    "Usuários da rede": "Usuarios de la red",
    "Usuários de frentistas": "Usuarios de playeros",
    "Usuários de locais": "Usuarios de locales",
    "Usuários do sistema": "Usuarios del sistema",
    "Validar Cupom": "Validar Cupón",
    "Validação Quality": "Validación Quality",
    "Valores CTT": "Valores CTT",
    "Valores por parceiros": "Valores por socios",
    "Vendidos": "Vendidos",
    "Versões do app": "Versiones de la aplicación",
    "Visualização de Anúncios": "Visualización de Anuncios",
    "Vitalícios": "Vitalicios",
    "Visão geral": "Visión general",
};

export default catalogo;
